/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import NoSsr from "@material-ui/core/NoSsr";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Autocomplete } from "@material-ui/lab";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import { SUGGESTIONS_FIELDS } from "./constants";

const useStyles = makeStyles({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    padding: "10px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  label: {
    padding: "10px 0",
  },
});

const SuggestionsFields = ({
  open,
  handleClose,
  familyFields,
  getSuggestions,
}) => {
  const classes = useStyles();

  const [selectedOptions, setSelectedOptions] = useState(familyFields);
  const body = (
    <div className={classes.paper}>
      <div className="custom-autocomplete-modal">
        <div className="close-icon-modal" onClick={handleClose}>
          <i>
            <CloseIcon />
          </i>
        </div>
        <Autocomplete
          multiple
          id="sugeestion-fields"
          value={selectedOptions}
          className="autocomplete-chip"
          onChange={(event, newValue) => {
            setSelectedOptions(newValue);
            getSuggestions(newValue);
          }}
          options={SUGGESTIONS_FIELDS}
          getOptionLabel={(option) => option}
          defaultValue={[...selectedOptions]}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                label={option}
                {...getTagProps({ index })}
                deleteIcon={<CloseIcon />}
              />
            ))
          }
          renderInput={(params) => (
            <>
              <label className={classes.label}>
                Suggestions based on the following fields
              </label>
              <TextField {...params} variant="outlined" placeholder="type..." />
            </>
          )}
        />
      </div>
    </div>
  );
  return (
    <NoSsr>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="autocomplete-modal"
      >
        {body}
      </Modal>
    </NoSsr>
  );
};

export default SuggestionsFields;
